import { createSlice } from "@reduxjs/toolkit";
import { getAllAilments } from "../API/SubAilments";

const initialState = {
    getallAilments: [],
    loading: false,
    error: null,
};

const SubAilmentsSlice = createSlice({
  name: "Ailments",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllAilments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllAilments.fulfilled, (state, action) => {
        state.loading = false;
        state.getallAilments = action.payload.data;
      })
      .addCase(getAllAilments.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
      })

  },
});

export default SubAilmentsSlice.reducer;